module.exports = __webpack_public_path__ + "img/mbal_web.15fe05cc.png";